/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The name of the network a card transaction is routed through.
 */
export const CardIssuingNetwork = {
  Discover: "discover",
  Shazam: "shazam",
  Visa: "visa",
} as const;
/**
 * The name of the network a card transaction is routed through.
 */
export type CardIssuingNetwork = ClosedEnum<typeof CardIssuingNetwork>;

/** @internal */
export const CardIssuingNetwork$inboundSchema: z.ZodNativeEnum<
  typeof CardIssuingNetwork
> = z.nativeEnum(CardIssuingNetwork);
/** @internal */
export const CardIssuingNetwork$outboundSchema: z.ZodNativeEnum<
  typeof CardIssuingNetwork
> = CardIssuingNetwork$inboundSchema;
